import React from "react";
import { Container } from "./styles";
import Logo from "../../ui/Logo";
import ConnectWalletButton from "../../ui/buttons/ConnectWalletButton";

import svgReddit from "../../../assets/images/reddit.svg";
import svgDiscord from "../../../assets/images/discord.svg";
import svgYoutub from "../../../assets/images/youtub.svg";
import svgAnnouncement from "../../../assets/images/Announcement.svg";
import svgTwitter from "../../../assets/images/twitter.svg";
import svgMedium from "../../../assets/images/medium.svg";
import svgTelegram from "../../../assets/images/telegram.svg";
import svgCoingecko from "../../../assets/images/coingecko.svg";
import TransactionButton from "../../ui/buttons/TransactionButton";

const Footer = () => {
  const socialMedias = [
    // {
    //   name: "Reddit",
    //   icon: <img src={svgReddit} />,
    //   href: "",
    // },
    // {
    //   name: "Discord",
    //   icon: <img src={svgDiscord} />,
    //   href: "#",
    // },
    {
      name: "Twitter",
      icon: <img src={svgTwitter} />,
      href: "#",
    },
    // {
    //   name: "Medium",
    //   icon: <img src={svgMedium} />,
    //   href: "",
    // },
    // {
    //   name: "Youtube",
    //   icon: <img src={svgYoutub} />,
    //   href: "",
    // },
    {
      name: "Telegram",
      icon: <img src={svgTelegram} />,
      href: "#",
    },
    // {
    //   name: "CoinGecko",
    //   icon: <img src={svgCoingecko} />,
    //   href: "",
    // },
    // {
    //   name: "Announcement",
    //   icon: <img src={svgAnnouncement} />,
    //   href: "",
    // },
  ];
  const pathname = window.location.pathname;
  return (
    <Container>
      <div className="footer-row">
        <Logo />
        <div className="social-content">
          {socialMedias.map((socialMedia, index) => (
            <a key={`socialmedia__${index}`} href={socialMedia.href}>
              {socialMedia.icon}
              {/* <p>{socialMedia.name}</p> */}
            </a>
          ))}
        </div>
        {pathname == "/" && (
          <a href="/farm">
            <TransactionButton name="DAPP" />
          </a>
        )}
        {(pathname == "/farm" ||
          pathname == "/swap" ||
          pathname == "/dapp" ||
          pathname == "/pool") && <ConnectWalletButton />}
      </div>
      <div className="footer-row" style={{ justifyContent: "center" }}>
        <p>© 2023 Grokcoin</p>
      </div>
    </Container>
  );
};

export default Footer;
